import React from "react";
const OttTable = ()=>{
    return(
        <>
        <h3>OTT</h3>
        </>
    )
}

export default OttTable;